const { REACT_APP_ENV } = process.env;
export const supportedChains = [
  {
    name: "Binance Smart Chain",
    short_name: "bsc",
    chain: "smartchain",
    network: "mainnet",
    chain_id: 56,
    network_id: 56,
    rpc_url: "https://bsc-dataseed1.defibit.io/",
    native_currency: {
      symbol: "BNB",
      name: "BNB",
      decimals: "18",
      contractAddress: "",
      balance: "",
    },
  },
  {
    name: "Binance Smart Chain Testnet",
    short_name: "bsc",
    chain: "smartchain",
    network: "testnet",
    chain_id: 97,
    network_id: 97,
    rpc_url: "https://data-seed-prebsc-1-s1.binance.org:8545/",
    native_currency: {
      symbol: "BNB",
      name: "BNB",
      decimals: "18",
      contractAddress: "",
      balance: "",
    },
  },
];

export const newWorksBnb = {
  beta: {
    chainId: `0x61`,
    rpcUrls: ["https://data-seed-prebsc-1-s1.binance.org:8545/"],
    chainName: "Binance Smart Chain Testnet",
    nativeCurrency: {
      name: "BNB",
      symbol: "BNB",
      decimals: 18,
    },
    blockExplorerUrls: ["https://testnet.bscscan.com/"],
  },
  prod: {
    chainId: `0x38`,
    rpcUrls: ["https://bsc-dataseed.binance.org/"],
    chainName: "Binance Smart Chain Mainnet",
    nativeCurrency: {
      name: "BNB",
      symbol: "BNB",
      decimals: 18,
    },
    blockExplorerUrls: ["https://bscscan.com/"],
  },
};

const polygonNets = {
  beta: {
    chainId: `0x13881`,
    rpcUrls: ["https://polygon-mumbai-bor.publicnode.com"],
    chainName: "Polygon Mumbai",
    nativeCurrency: {
      name: "MATIC",
      symbol: "MATIC",
      decimals: 18,
    },
    blockExplorerUrls: ["https://mumbai.polygonscan.com"],
  },
  prod: {
    chainId: `0x89`,
    rpcUrls: ["https://polygon-rpc.com"],
    chainName: "Polygon Mainnet",
    nativeCurrency: {
      name: "MATIC",
      symbol: "MATIC",
      decimals: 18,
    },
    blockExplorerUrls: ["https://mumbai.polygonscan.com"],
  },
};

const lineaNets = {
  beta: {
    chainId: `0xe705`,
    rpcUrls: ["https://rpc.sepolia.linea.build"],
    chainName: "Linea Testnet",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: 18,
    },
    blockExplorerUrls: ["https://sepolia.lineascan.build/"],
  },
  prod: {
    chainId: `0xe708`,
    rpcUrls: ["https://rpc.linea.build"],
    chainName: "Linea",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: 18,
    },
    blockExplorerUrls: ["https://lineascan.build/"],
  },
};

const ethNets = {
  beta: {
    chainId: `0xaa36a7`,
    rpcUrls: ["https://ethereum-sepolia-rpc.publicnode.com"],
    chainName: "Sepolia Testnet",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: 18,
    },
    blockExplorerUrls: ["https://sepolia.etherscan.io/"],
  },
  prod: {
    chainId: `0x1`,
    rpcUrls: ["https://ethereum-rpc.publicnode.com"],
    chainName: "Ethereum Mainnet",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: 18,
    },
    blockExplorerUrls: ["https://etherscan.io/"],
  },
};

export const networkBinance =
  REACT_APP_ENV === "prod" ? newWorksBnb.prod : newWorksBnb.beta;
export const networkPolygon =
  REACT_APP_ENV === "prod" ? polygonNets.prod : polygonNets.beta;
export const networkLinea =
  REACT_APP_ENV === "prod" ? lineaNets.prod : lineaNets.beta;
export const networkETH =
  REACT_APP_ENV === "prod" ? ethNets.prod : ethNets.beta;

export const CHIAN_TYPE = {
  BSC: "bsc",
  ETH: "eth",
  POLYGON: "polygon",
  LINEA: "linea",
};

export const CHANIN_NETWORK_MAP = {
  [CHIAN_TYPE.BSC]: networkBinance,
  [CHIAN_TYPE.POLYGON]: networkPolygon,
  [CHIAN_TYPE.LINEA]: networkLinea,
  [CHIAN_TYPE.ETH]: networkETH,
};
